import React, { useEffect, useState } from "react";
import { useAuth } from "./auth";
import { useNavigate } from "react-router-dom";
import {
  deleteRoom,
  getRoomByID,
  getTenant,
  getTenantByRoom,
} from "./apiService";

const DeleteRoom = () => {
  const [roomname, setRoomname] = useState("");
  const [beds, setBeds] = useState("");
  const [errors, setErrors] = useState({});
  const [tenantdetails, setTenantdetails] = useState([]);
  const { roomid } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    getRoomByID(roomid)
      .then((res) => {
        // console.log(res);
        setRoomname(res.roomname);
        setBeds(res.beds);
      })
      .catch((e) => console.log(e));

    getTenantByRoom(roomid).then((res) => {
      setTenantdetails(res);
    });
  }, [roomid]);

  const handleRoomDeleteSubmit = () => {
    let errors = {};

    const fguests = tenantdetails.filter((tenant) => {
      return tenant.roomNo === roomid;
    });

    if (Object.keys(fguests).length > 0) {
      alert(
        "Guests were using " +
          beds +
          " beds. Please vacate(delete) the guests before deleting Room...!!"
      );
      errors.beds = "Not able to delete the room with guests";
    }

    setErrors(errors);

    if (Object.keys(errors).length === 0) {
      deleteRoom(roomid);

      navigate("/Dashboard/MyPGDetails");
    }
  };
  return (
    <div className="container">
      <div className="header">DELETE ROOM</div>
      <div className="label">Room Name : {roomname}</div>

      <div className="label">Room Bed Count : {beds}</div>
      {errors.beds ? <div className="errortext">{errors.beds}</div> : null}
      <input
        type="submit"
        className="btn-cls"
        value="Delete"
        onClick={handleRoomDeleteSubmit}
      />
    </div>
  );
};

export default DeleteRoom;
